import { apiClient } from "../../../services/axiosInstance";
import { ServerResponse, Account } from "../../../types";
import sha256 from "crypto-js/sha256";

const JS_SALT = "differenthash";

// Email change
export function postChangeEmail(email: string, password: string) {
  const password_hash = sha256(password + JS_SALT).toString();
  return apiClient.post<ServerResponse<Account>>("/v1/account/email", {
    meta: [],
    payload: { email, password_hash },
  });
}

// Password change
export function postChangePassword(oldPassword: string, newPassword: string) {
  const old_password_hash = sha256(oldPassword + JS_SALT).toString();
  const new_password_hash = sha256(newPassword + JS_SALT).toString();

  return apiClient.post<ServerResponse<Account>>("/v1/account/password", {
    meta: [],
    payload: { old_password_hash, new_password_hash },
  });
}

// Email notification settings
export type EmailSettingItem = {
  id: string;
  group_id: number;
  name: string;
  enabled: boolean;
};

export function getEmailSettings() {
  return apiClient.get<ServerResponse<{ email_settings: EmailSettingItem[] }>>(
    "/v1/account/email-settings",
  );
}

export function postEmailSettings(settings: Record<string, boolean>) {
  return apiClient.post<ServerResponse<{ success: boolean }>>(
    "/v1/account/email-settings",
    {
      meta: [],
      payload: settings,
    },
  );
}

// Credits / promo code
export function postClaimCredit(token: string) {
  return apiClient.post<ServerResponse<Account>>("/v1/account/claim-credit", {
    meta: [],
    payload: { token },
  });
}

// Avatar upload
export function postAvatarUpload(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post<ServerResponse<Account>>("/v1/account/avatar", formData);
}
